module.exports = __webpack_public_path__ + "img/11.cf9be8ba.jpg";